<template>
    <form-modal
        headline="Dokument hinzufügen"
        :value="true"
        :is-loading="isLoading"
        @input="$emit('input', $event)"
        @confirm="onSubmit"
    >
        <div class="form-group mr-12">
            <label for="title">Name <sup>*</sup></label>
            <input
                v-model="form.name"
                class="form-control"
                id="name"
                type="text"
                autocomplete="off"
                autofocus
                required
            />
        </div>

        <div class="form-group mr-12">
            <label for="date">Ausstelldatum</label>
            <input class="form-control" id="date" type="date" v-model="form.date" />
        </div>

        <div v-if="!document" class="form-group mr-12">
            <label>Datei <sup>*</sup></label>
            <drop-file v-model="form.file" />
        </div>

        <div class="form-group mr-12">
            <label for="tags">Tags</label>
            <select class="form-control form-select" id="tags" v-model="form.tags" multiple>
                <option v-for="tag in availableTags" :key="`tag-${tag.id}`" :value="tag.id">{{ tag.name }}</option>
            </select>
        </div>

        <div class="form-group mr-12">
            <label for="description">Notizen</label>
            <textarea class="form-control" id="description" v-model="form.description" rows="3" />
        </div>
    </form-modal>
</template>

<script>
import { format } from 'date-fns'
import FormModal from '@/components/ui/modals/FormModal.vue'
import DropFile from '@/components/form/DropFile.vue'

export default {
    name: 'AddDocumentModal',

    components: { DropFile, FormModal },

    props: {
        document: { type: Object, default: null },
        documentStatus: { type: String, required: true },
    },

    data () {
        return {
            isLoading: false,
            form: {
                name: '',
                date: this.getCurrentDate(),
                file: null,
                tags: [],
                description: '',
            },
            availableTags: [],
        }
    },

    async mounted () {
        await this.loadAvailableTags()

        if (this.document) {
            this.prefillForm()
        }
    },

    methods: {
        async onSubmit () {
            try {
                this.isLoading = true

                const formData = this.createFormData()
                const url = this.document ? '/document/edit' : '/document/add'
                const response = await this.$http.post(url, formData)

                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.$toast.open({ type: 'success', message: response.data.successHtml })
                this.$emit('add', response.data.entity)
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoading = false
            }
        },

        createFormData () {
            const formData = new FormData()
            formData.append('name', this.form.name)
            formData.append('date', this.form.date || '')
            formData.append('tags', this.form.tags ? this.form.tags.join(',') : '')
            formData.append('status', this.documentStatus)
            formData.append('description', this.form.description || '')

            if (!this.document) {
                formData.append('file', this.form.file)
            } else {
                formData.append('id', this.document.id)
            }

            return formData
        },

        async loadAvailableTags () {
            try {
                const response = await this.$http.get('/document-tags')
                this.availableTags = response.data
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: 'Fehler beim Laden der Tags' })
            }
        },

        prefillForm () {
            this.form.name = this.document.name
            this.form.description = this.document.description.replace(/<\s*\/?br\s*\/?>/gi, '')

            if (this.document.date) {
                this.form.date = this.$date(new Date(this.document.date), 'yyyy-MM-dd')
            }

            this.document.tags.forEach(tagName => {
                const tag = this.availableTags.find(x => x.name === tagName)
                if (tag) {
                    this.form.tags.push(tag.id)
                }
            })
        },

        getCurrentDate () {
            return format(new Date(), 'yyyy-MM-dd')
        },
    },
}
</script>

<style lang="scss" scoped>
.form-select {
    height: 115px !important;
}
</style>
